<mat-icon class="default">{{ calendarEvent.icon || 'event' }}</mat-icon>
<mat-icon class="add">add</mat-icon>
<div class="title">
  {{ calendarEvent.title }}
  <!--   {{event.start|date:'HH:mm'}} – {{(event.start + event.duration)|date:'HH:mm'}}-->
</div>
<div class="planner-time-remaining-shared">{{ calendarEvent.duration|msToString }}</div>
